import { createServerFn } from "@tanstack/react-start";

export type HistoryPoint = {
  date: string; // YYYY-MM-DD
  price24k: number;
  price22k: number;
};

export type CountryHistory = {
  country: "pakistan" | "india";
  unit: string;
  currency: string;
  points: HistoryPoint[];
};

export const getGoldHistory = createServerFn({ method: "GET" })
  .inputValidator((data: { country: "pakistan" | "india" }) => data)
  .handler(async ({ data }): Promise<CountryHistory> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const sinceIso = new Date(Date.now() - 180 * 24 * 60 * 60 * 1000)
      .toISOString()
      .slice(0, 10);

    const { data: rows, error } = await supabaseAdmin
      .from("gold_rates_history")
      .select("snapshot_date, price_24k, price_22k, unit, currency")
      .eq("country", data.country)
      .gte("snapshot_date", sinceIso)
      .order("snapshot_date", { ascending: true });

    const unit = data.country === "pakistan" ? "per_tola" : "per_10g";
    const currency = data.country === "pakistan" ? "PKR" : "INR";

    if (error || !rows) {
      return { country: data.country, unit, currency, points: [] };
    }

    return {
      country: data.country,
      unit: rows[0]?.unit ?? unit,
      currency: rows[0]?.currency ?? currency,
      points: rows.map((r) => ({
        date: r.snapshot_date as string,
        price24k: Number(r.price_24k),
        price22k: Number(r.price_22k),
      })),
    };
  });